module.exports = __webpack_public_path__ + "static/img/1.a6949a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moho/1.png
// module id = P7Vo
// module chunks = 0